<template>
  <div>
    <slots-head
      :item="item"
      :type="type"
      @saveNameEdit="(value, item) => saveNameEdit(value, item)"
      @deleteItem="(item) => deleteItem(item)"
    ></slots-head>
    <div style="width:100%;height:100%;overflow:hidden;">
      <a-tabs :value="tabKey" @change="callback" size="small">
        <template v-for="tabItem in areaList">
          <a-tab-pane :key="tabItem.name">
            <span slot="tab">
              <div>{{ tabItem.completedValue }}/{{ tabItem.totalValue }}</div>
              <div>
                {{ $t(tabItem.name) }}
              </div>
            </span>
          </a-tab-pane>
        </template>
      </a-tabs>
      <div id="scorll-chart" style="width:100%;height:calc(100% - 40px);overflow-x:auto;">
        <div :style="{ width: autoWidth, height: '100%' }" ref="myChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './cardmixin.vue'
import { WorkRecordStatisticsServiceProxy } from '@/service-proxies/app-v2/work-record.service-proxies'
const wrsp = new WorkRecordStatisticsServiceProxy()

export default {
  name: 'regional-completion',
  mixins: [mixin],
  props: {
    unit: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabKey: '',
      dataSource: [],
      myChart: null,
      areaList: [],
      maxY: 0,
      autoWidth: '100%'
    }
  },
  async mounted() {
    const area = await wrsp.getAreaWorkRecordStatistics()
    if (area) {
      this.areaList = area
      this.tabKey = area[0].name
    }
    this.myChart = this.$echarts.init(this.$refs.myChart)
    this.myChart.setOption(this.chartOption)
    this.callback(this.tabKey)
  },
  watch: {
    chartOption: {
      handler(val) {
        this.myChart.setOption(val, true)
        // this.myChart.resize()
      },
      deep: true
    },
    tabKey: {
      handler() {
        if (this.myChart) {
          this.myChart.setOption(this.chartOption, true)
        }
      },
      deep: true,
      immediate: true
    },
    unit: {
      handler() {
        if (this.myChart) {
          setTimeout(() => {
            this.myChart.resize()
          }, 300)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    chartOption() {
      let option = {
        legend: {
          show: false
        },
        color: ['#457cbe', '#5cdbd3'],
        tooltip: {},
        grid: {
          left: '35',
          right: '20',
          bottom: '35',
          top: '20'
          // containLabel: true
        },
        dataset: {
          source: this.dataSource
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: false,
            interval: 0,
            // rotate: 30,
            // margin: 15,
            fontSize: 12,
            formatter: (val) => {
              var strs = val.split('') //字符串数组
              var str = ''
              for (var i = 0, s; (s = strs[i++]); ) {
                //遍历字符串数组
                str += s
                if (val.indexOf('自治区') !== -1 && i === strs.length - 3) {
                  str += '\n' //按需要求余
                } else if (val.indexOf('特别行政区') !== -1 && i === strs.length - 5) {
                  str += '\n' //按需要求余
                }
              }
              return str
            }
          }
        },
        yAxis: {
          minInterval: 1,
          max: this.maxY
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: 'bar',
            barWidth: '60%',
            barGap: '-100%',
            align: 'center',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top', //top
                  formatter: (p) => {
                    return p.data[1] === 0 && p.data[2] === 0
                      ? ''
                      : '{a|' + p.data[2] + '}{c|/}{b|' + p.data[1] + '}'
                  },
                  rich: {
                    a: {
                      color: '#5cdbd3',
                      fontSize: 16,
                      padding: [0, 5, 0, 0]
                    },
                    b: {
                      color: '#5cdbd3',
                      fontSize: 16,
                      padding: [0, 0, 0, 5]
                    },
                    c: {
                      color: '#5cdbd3'
                    }
                  },
                  textStyle: {
                    //数值样式
                    fontSize: 16
                  }
                }
              }
            }
          },
          {
            type: 'bar',
            zlevel: 1,
            barWidth: '60%',
            align: 'center'
          }
        ]
      }
      return option
    }
  },
  methods: {
    async callback(key) {
      this.tabKey = key
      this.dataSource = [['product', '总数', '完成']]
      this.maxY = 0
      const data = await wrsp.getProvinceWorkRecordStatistics(key)
      if (data && data.length) {
        const dataSort = data.sort((a, b) => {
          return b.totalValue - a.totalValue
        })
        const maxdata = dataSort.map((res) => res.totalValue)
        if (data.length > 5) {
          this.autoWidth = 80 * data.length + 'px'
        } else {
          this.autoWidth = '100%'
        }
        this.maxY = maxdata[0] + 2
        const datt = dataSort.map((res) => [res.name, res.totalValue, res.completedValue])
        this.dataSource = this.dataSource.concat(datt)
        setTimeout(() => {
          // const domeu = (scorll-chart)
          this.myChart.resize()
        }, 5)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-tabs-nav-scroll {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .ant-tabs-nav {
  width: 20%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
/deep/ .ant-tabs-nav div {
  width: 100%;
  line-height: 18px;
}
/deep/.ant-tabs-nav .ant-tabs-tab {
  text-align: center;
  margin: 0;
}
/deep/ .ant-tabs-ink-bar {
  width: 100% !important;
}
/deep/ .ant-tabs .ant-tabs-small-bar .ant-tabs-tab {
  padding: 0 8px 4px;
}
</style>
